<picture>
  @for (brandLogoFilePath of config()?.BrandLogoFilePaths; track brandLogoFilePath)
  {
  <source [srcset]="brandLogoFilePath" [type]="getMimeType(brandLogoFilePath)" />
  }
  <img itemprop="image" [alt]="config()?.BrandName" loading="lazy">
</picture>
